import React, { useState } from "react"
import { Button, Col, Dropdown, InputGroup, Row } from "react-bootstrap"
import { useAllReportsContext } from "./contextProviders/allReportsContext"
import { dataSource } from "../../services/dataSource"
import { REP_V2 } from "../../shared/Data/typeDirs"

export function CopyToOppositeController(props){
  const [selectedReport, setSelectedReport] = useState(false)
  const {reports_v2} = useAllReportsContext()
  return (
    <Row style={{padding: '5px 0px'}}>
      <InputGroup>
        <Dropdown onSelect={(eventKey)=>setSelectedReport(reports_v2.find(rep=>rep._id === eventKey))}>
          <Dropdown.Toggle>{selectedReport?selectedReport.name : 'Select a Report'}</Dropdown.Toggle>
          <Dropdown.Menu>
            {reports_v2.map(rep=><Dropdown.Item eventKey={rep._id} >{rep.name}</Dropdown.Item>)}
          </Dropdown.Menu>
        </Dropdown>
        <Button onClick={()=>dataSource('remDb')[REP_V2].copyToOppositeRem({_id:selectedReport._id, to_azure:true})}>Copy to Opposite DB</Button>
      </InputGroup>
    </Row>
  )
}